var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLockIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  stroke: "currentColor",
  strokeWidth: 2
}, /*#__PURE__*/React.createElement("rect", {
  width: 14,
  height: 10,
  x: 5,
  y: 10,
  rx: 2
}), /*#__PURE__*/React.createElement("path", {
  d: "M7 10c0-6 4-6 5-6s5 0 5 6"
}))));
export default SvgLockIcon;